const LEVELS = ['error', 'warn', 'info', 'http', 'verbose', 'debug', 'silly'];

const ENTRY_RE = new RegExp('^(' + LEVELS.join('|') + ')\\s*:\\s?([\\s\\S]*)$');
const TIMESTAMP_RE =
    /^(\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?Z?)\s*(?:-\s?([\s\S]*))?$/;

/**
 * The logger writes errors as a pair of lines: a bare "info: <ISO>" line
 * carrying the timestamp followed by "error: <message>" without one. The
 * stack trace comes embedded as an escaped JSON string on the error line.
 */
function unstack(message) {
    let start = message.indexOf('{');
    while (start !== -1) {
        try {
            const parsed = JSON.parse(message.slice(start));
            if (!parsed || typeof parsed.stack !== 'string') return message;

            const left = message.slice(0, start).trimEnd();
            const firstLine = parsed.stack
                .split('\n')[0]
                .replace(/^Error:\s*/, '');
            if (left === '' || left === firstLine) return parsed.stack;
            return left + '\n' + parsed.stack;
        } catch (err) {
            start = message.indexOf('{', start + 1);
        }
    }
    return message;
}

function toEntry(level, rest) {
    const match = rest.match(TIMESTAMP_RE);
    if (!match) return { timestamp: null, level, message: unstack(rest) };

    const date = new Date(match[1]);
    return {
        timestamp: isNaN(date.getTime()) ? null : date,
        level,
        message: unstack(match[2] || ''),
    };
}

/**
 * Parses the raw text of a winston log file into entries:
 * { timestamp: Date|null, level: string, message: string }
 * Lines that do not start an entry are appended to the previous one.
 */
export function parseLogs(text) {
    const entries = [];
    if (!text || typeof text !== 'string') return entries;

    for (const line of text.split(/\r?\n/)) {
        if (!line) continue;

        const match = line.match(ENTRY_RE);
        if (match) {
            const entry = toEntry(match[1], match[2]);
            const previous = entries[entries.length - 1];
            if (
                !entry.timestamp &&
                entry.level === 'error' &&
                previous &&
                previous.timestamp &&
                previous.message === ''
            ) {
                previous.level = 'error';
                previous.message = entry.message;
            } else {
                entries.push(entry);
            }
        } else if (entries.length) {
            entries[entries.length - 1].message += '\n' + line;
        } else {
            entries.push({ timestamp: null, level: 'info', message: line });
        }
    }
    return entries;
}
